import { donutSegments, type DonutInput } from "@/lib/chart-math";

interface DonutProps {
  segments: DonutInput[];
  size?: number;
  stroke?: number;
  centerLabel?: string;
}

export function Donut({
  segments,
  size = 140,
  stroke = 18,
  centerLabel = "BESTELLUNGEN",
}: DonutProps) {
  const layout = donutSegments(segments, { size, stroke });
  const cx = size / 2;
  const cy = size / 2;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle
        cx={cx}
        cy={cy}
        r={layout.radius}
        stroke="var(--line-2)"
        strokeWidth={stroke}
        fill="none"
      />
      {layout.segments.map((s, i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={layout.radius}
          stroke={s.color}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={`${s.dash} ${layout.circumference - s.dash}`}
          strokeDashoffset={-s.offset}
          transform={`rotate(-90 ${cx} ${cy})`}
          strokeLinecap="butt"
        />
      ))}
      {layout.total > 0 && (
        <>
          <text
            x={cx}
            y={cy - 2}
            textAnchor="middle"
            fontFamily="var(--h-font)"
            fontWeight="800"
            fontSize="22"
            fill="var(--ink)"
          >
            {layout.total}
          </text>
          <text
            x={cx}
            y={cy + 14}
            textAnchor="middle"
            fontFamily="var(--b-font)"
            fontSize="10"
            fill="var(--muted)"
            letterSpacing="1"
          >
            {centerLabel}
          </text>
        </>
      )}
    </svg>
  );
}
